/**
 * 系统主题配置
 * 每套主题包含：
 *  - primary: 主色
 *  - primaryHover: 悬停色
 *  - primaryLight: 浅色（浅底/柔和背景）
 *  - primaryDark: 深色（文字/边框）
 *  - primaryDarker: 更深色（侧边栏深处）
 *  - siderGradientFrom / siderGradientTo: 侧边栏垂直渐变
 *  - bgPage: 页面背景色
 *  - loginGradient: 登录页背景渐变（数组4段）
 */

export const THEMES = {
  green: {
    key: 'green',
    label: '清新绿',
    icon: '🌿',
    primary: '#52c41a',
    primaryHover: '#73d13d',
    primaryLight: '#95de64',
    primaryLighter: '#d9f7be',
    primaryBg: '#f6ffed',
    primaryDark: '#237804',
    primaryDarker: '#135200',
    siderGradientFrom: '#237804',
    siderGradientTo: '#135200',
    loginGradient: ['#e8f5e9', '#c8e6c9', '#a5d6a7', '#81c784'],
    chartColors: ['#52c41a', '#95de64', '#237804', '#389e0d'],
  },
  blue: {
    key: 'blue',
    label: '海洋蓝',
    icon: '💧',
    primary: '#1890ff',
    primaryHover: '#40a9ff',
    primaryLight: '#69c0ff',
    primaryLighter: '#bae7ff',
    primaryBg: '#e6f7ff',
    primaryDark: '#003a8c',
    primaryDarker: '#002766',
    siderGradientFrom: '#003a8c',
    siderGradientTo: '#002766',
    loginGradient: ['#e6f7ff', '#bae7ff', '#91d5ff', '#69c0ff'],
    chartColors: ['#1890ff', '#69c0ff', '#003a8c', '#096dd9'],
  },
  purple: {
    key: 'purple',
    label: '典雅紫',
    icon: '🔮',
    primary: '#722ed1',
    primaryHover: '#9254de',
    primaryLight: '#b37feb',
    primaryLighter: '#efdbff',
    primaryBg: '#f9f0ff',
    primaryDark: '#391085',
    primaryDarker: '#22075e',
    siderGradientFrom: '#391085',
    siderGradientTo: '#22075e',
    loginGradient: ['#f9f0ff', '#efdbff', '#d3adf7', '#b37feb'],
    chartColors: ['#722ed1', '#b37feb', '#391085', '#531dab'],
  },
  orange: {
    key: 'orange',
    label: '活力橙',
    icon: '🔥',
    primary: '#fa8c16',
    primaryHover: '#ffa940',
    primaryLight: '#ffc069',
    primaryLighter: '#ffe7ba',
    primaryBg: '#fff7e6',
    primaryDark: '#873800',
    primaryDarker: '#612500',
    siderGradientFrom: '#873800',
    siderGradientTo: '#612500',
    loginGradient: ['#fff7e6', '#ffe7ba', '#ffd591', '#ffc069'],
    chartColors: ['#fa8c16', '#ffc069', '#873800', '#d46b08'],
  },
  red: {
    key: 'red',
    label: '品牌红',
    icon: '🌹',
    primary: '#f5222d',
    primaryHover: '#ff4d4f',
    primaryLight: '#ff7875',
    primaryLighter: '#ffccc7',
    primaryBg: '#fff1f0',
    primaryDark: '#820014',
    primaryDarker: '#5c0011',
    siderGradientFrom: '#820014',
    siderGradientTo: '#5c0011',
    loginGradient: ['#fff1f0', '#ffccc7', '#ffa39e', '#ff7875'],
    chartColors: ['#f5222d', '#ff7875', '#820014', '#cf1322'],
  },
};

export const DEFAULT_THEME_KEY = 'green';

export const getTheme = (key) => THEMES[key] || THEMES[DEFAULT_THEME_KEY];

/**
 * 将主题对象应用到 document 的 CSS 变量上
 */
export const applyThemeToDocument = (theme) => {
  const root = document.documentElement;
  root.style.setProperty('--primary-color', theme.primary);
  root.style.setProperty('--primary-hover', theme.primaryHover);
  root.style.setProperty('--primary-light', theme.primaryLight);
  root.style.setProperty('--primary-lighter', theme.primaryLighter);
  root.style.setProperty('--primary-bg', theme.primaryBg);
  root.style.setProperty('--primary-dark', theme.primaryDark);
  root.style.setProperty('--primary-darker', theme.primaryDarker);
  root.style.setProperty('--sider-gradient-from', theme.siderGradientFrom);
  root.style.setProperty('--sider-gradient-to', theme.siderGradientTo);
  root.style.setProperty('--login-gradient-1', theme.loginGradient[0]);
  root.style.setProperty('--login-gradient-2', theme.loginGradient[1]);
  root.style.setProperty('--login-gradient-3', theme.loginGradient[2]);
  root.style.setProperty('--login-gradient-4', theme.loginGradient[3]);
};
